import { render, staticRenderFns } from "./subscribers.vue?vue&type=template&id=c3e2a4da&"
import script from "./subscribers.vue?vue&type=script&lang=js&"
export * from "./subscribers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports